export const PRODUCTIVITY_CURRENCIES = [
  "USD",
  "EUR",
  "GBP",
  "AUD",
  "CHF",
] as const;

export type ProductivityCurrency = (typeof PRODUCTIVITY_CURRENCIES)[number];
